import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import createPersistedState from 'vuex-persistedstate'
import homeState from "./modules/homeStore";
import motherState from "./modules/motherStore";
import channelState from "./modules/channel";
import recommendState from "./modules/recommend";
import renovation from "./modules/renovation";
import shoppingguide from "./modules/shoppingguide"
import contentManage from "./modules/contentManage"

const vuexPersisted = createPersistedState();

const state = {
  count: 1,
  modelVisiable: false,
  breadCrumbList: [],
  lastScrollTop: 0,
  novaItemDetail: {}
};

const mutations = {
  add(state) {
    state.count++;
  },
  reduce(state) {
    state.count--;
  },
  addbread(state, items) {
    console.log(items + "ss");
    //强制v-for重新渲染列表
    state.breadCrumbList = null;
    state.breadCrumbList = items;
  },
  setLastScrollTop(state, scrollTop) {
    state.lastScrollTop = scrollTop;
  },
  setNovaItemDetail(state, detail) {
    state.novaItemDetail = detail;
  }
};

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    homeState,
    motherState,
    channelState,
    recommendState,
    renovation,
    shoppingguide,
    contentManage,
  },
  plugins: [vuexPersisted]
});
